import ApiService from "@/core/services/api.service";
const _ = require('lodash');

export const GET_DATA_KPI_PERSIONAL = "kraMonthlyResults";
export const SHOW_DATA_KPI_PERSIONAL = "kraManager/kraAndMeetingByUser";
export const GET_KRA_METTING = "kra-manager/weekly-meeting-criteria";
export const UPDATE_DATA_KPI_TEAM_LEAD = "kraManager/details/update/team-lead";
export const UPDATE_DATA_KPI_PERSIONAL = "kraManager/details/update/persional";
export const GET_DATA_DETAIL_KPI = "kraManager/details";
export const TEAM_LEAD_UPDATE_KRA = "kra-manager/update-kra"
export const TEAM_LEAD_CREATE_KRA = "kra-manager/add-kra";
export const TEAM_LEAD_KRA_HISTORY = "kra-manager/history";
export const GET_LIST_RANKING = "level-approval-request/promotion-plans"
export const GET_MY_RANKING = "level-approval-request/current-level-dashboard"

const state = {
    errors: null,
};

const getters = {};

const actions = {
    [GET_DATA_KPI_PERSIONAL](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(GET_DATA_KPI_PERSIONAL, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [GET_DATA_DETAIL_KPI](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(GET_DATA_DETAIL_KPI, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [GET_KRA_METTING](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(GET_KRA_METTING, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [SHOW_DATA_KPI_PERSIONAL](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(SHOW_DATA_KPI_PERSIONAL, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [UPDATE_DATA_KPI_PERSIONAL](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(UPDATE_DATA_KPI_PERSIONAL, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [UPDATE_DATA_KPI_TEAM_LEAD](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(UPDATE_DATA_KPI_TEAM_LEAD, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [TEAM_LEAD_UPDATE_KRA](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(TEAM_LEAD_UPDATE_KRA, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [TEAM_LEAD_CREATE_KRA](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(TEAM_LEAD_CREATE_KRA, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [TEAM_LEAD_KRA_HISTORY](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(TEAM_LEAD_KRA_HISTORY, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [GET_LIST_RANKING](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(GET_LIST_RANKING, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [GET_MY_RANKING](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(GET_MY_RANKING, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },
}

const mutations = {};
export default {
    state,
    actions,
    mutations,
    getters
};
